import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JegyContent from './JegyContent';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../EsemenyekTooltips';

class JegyBase extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let cardStyle = {
      padding: 20
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {'Jegytípusok'}
              <CustomTooltip text={getTooltip('jegytipusok')} id="musorokTT" />
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <JegyContent {...this.props} globals={this.props.globals} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

JegyBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default JegyBase;
